module.exports = __webpack_public_path__ + "img/join-background-2.18846d4e.png";